import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ContactLayer from "../../components/message/ContactLayer";

const ContactPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Contact Page" />


        {/* SingleLayer */}
        <ContactLayer />

      </MasterLayout>
    </>
  );
};

export default ContactPage;
